import type { FunctionComponent } from "react";

import type { BillingCycle } from "~/components/posties/subscription-widget/types";

import { Container, CycleLabel, LabelContainer, Switch } from "./styles";

type Props = {
  billingCycle: BillingCycle;
  className?: string;
  handleChange: (billingCycle: BillingCycle) => void;
};

export const BillingCycleToggle: FunctionComponent<Props> = ({
  billingCycle,
  className,
  handleChange,
}) => {
  const renderLabel = (variant: BillingCycle) => {
    const computeViewModel = () => {
      const isSelected = billingCycle === variant;
      switch (variant) {
        case "monthly":
          return { cycle: "Monthly", isSelected };
        case "annual":
          return { cycle: "Yearly", isSelected };
      }
    };
    const viewModel = computeViewModel();

    return (
      <LabelContainer $isSelected={viewModel.isSelected} onClick={() => handleChange(variant)}>
        <CycleLabel>{viewModel.cycle}</CycleLabel>
      </LabelContainer>
    );
  };

  return (
    <Container className={className}>
      {renderLabel("monthly")}
      <Switch
        checked={billingCycle === "annual"}
        disableFocusRipple
        disableRipple
        onChange={event => handleChange?.(event.target.checked ? "annual" : "monthly")}
      />
      {renderLabel("annual")}
    </Container>
  );
};
